import { Injectable, inject } from '@angular/core';
import { Observable, lastValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { AlphaHttpClient } from './alpha-http-client';
import { BranchStateService } from './branch-state.service';

@Injectable({ providedIn: 'root' })
export class BPMService {
    private httpClient = inject(AlphaHttpClient);
    private branchStateService = inject(BranchStateService);

    private domainUrl = {
        type: 'environment',
        value: {
            __alpha_env__: 'ALPHA_UI_CONFIG_SERVICE_URL',
        },
    };

    fetchProcesses(projectId: string): Observable<any> {
        return this.httpClient.post(this.domainUrl, `/bpm/process/fetch-all`, {
            projectId,
        });
    }

    searchProcess(
        projectId: string,
        searchKey?: string,
        status?: 'COMPLETE' | 'INCOMPLETE' | '',
        skip?: number,
        limit?: number,
        sortby?: any,
    ): Observable<any> {
        return this.httpClient.post(this.domainUrl, `/bpm/process/search`, {
            projectId,
            searchKey,
            status,
            skip,
            limit,
            sortby,
        });
    }

    fetchTaskByTaskName(projectId: string, taskName: string) {
        return lastValueFrom(
            this.httpClient.post(this.domainUrl, `/bpm/task/search-by-taskname`, {
                projectId,
                taskName,
            }),
        );
    }

    fetchUploadMetadata(projectId: string): {
        method: 'post' | 'put' | undefined;
        url: string;
    } {
        let url = `${environment.ALPHA_UI_CONFIG_SERVICE_URL}/bpm/${projectId}/project-upload`;
        const branch = this.branchStateService.getBranch();
        if (branch) {
            url += `?branch=${branch}`;
        }
        return {
            method: 'post',
            url,
        };
    }

    uploadProject(file: File, projectId: string) {
        const formData = new FormData();
        formData.append('file', file, file.name);
        return this.httpClient.post(this.domainUrl, `/bpm/${projectId}/project-upload`, formData, {
            isFile: true,
        });
    }

    taskDefinitionMapping(taskDefinitions: TaskDefinitionsInterface[]) {
        return taskDefinitions.map((task: any) => {
            return {
                tdid: task.tdid,
                processName: task?.processDefinition?.processName,
                processDefinitionId: task?.processDefinition?.processDefinitionId,
                taskName: task.taskName,
                taskDefinitionId: task.taskDefinitionId,
                updatedAt: task.updatedAt,
                status: task?.status,
                processVersion: task.processDefinition?.processVersion,
            };
        });
    }

    deleteBpmService(bpm: any, projectId: string) {
        let { tdid } = bpm;
        return this.httpClient.post(this.domainUrl, `/bpm/process/remove`, { tdid, projectId });
    }
}

export interface TaskDefinitionsInterface {
    processName: string;
    processDefinitionId: string;
    processVersion: string;
    pdid: number;
    mainProcess: boolean;
    taskDefinitions: Array<{
        taskName: string;
        taskDefinitionId: string;
        taskVersion: string;
        tdid: number;
        mainTask: boolean;
        status: 'INCOMPLETE' | 'COMPLETE';
    }>;
}
